import * as actions from './actions'
import { success, failure } from 'utilities/actions'

export type State = {
  loginUrl: string;
  errors: any[];
  meta: any;
};

type Action = {
  type: string;
  data?: any;
  errors?: any[];
  meta?: any;
};

const initialState = {
  loginUrl: '',
  errors: [],
  meta: {}
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly loginUrl: ""; readonly errors: readonly []; readonly meta: {}; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case success(actions.API_SALESFORCE_PORTAL_JWT_INDEX):
      return { ...state, loginUrl: action.data }
    case failure(actions.API_SALESFORCE_PORTAL_JWT_INDEX):
      return {
        ...state,
        errors: [
          {title: 'Invalid client'}
        ],
      }
    default:
      return state
  }
}

export default reducer
